<template>
  <div id="more-relevant">
    <div class="ques-title">相关问题</div>
    <div class="aside-ques-list">
      <div class="ques-item" v-for="item in getRelatedQuizDetail" :key="item.id" @click="$emit('handler_getQuestionDetail', item.id)">
        <div class="ques-text">{{ item.topic }}</div>
        <div class="ques-icon"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'moreRelevant',
  data () {
    return {}
  },
  computed: {
    ...mapGetters([
      'getRelatedQuizDetail'
    ])
  }
}
</script>

<style scoped>
  #more-relevant {
    /*width: 375px;*/
    width: 100%;
  }

  .ques-title {
    height: 44px;
    padding-left: 41px;
    margin-bottom: 1px;
    font-size: 15px;
    color: #333333;
    line-height: 44px;
    letter-spacing: -0.36px;
    background: #fff url("../../icons/related-questions.svg") no-repeat 18px 14px;
  }

  .aside-ques-list {
    padding-left: 41px;
    background: #fff;
  }

  .ques-item {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    height: 44px;
    border-bottom: 1px solid #E0E0E0;
    font-size: 14px;
    color: #333333;
    line-height: 44px;
    letter-spacing: -0.36px;
    background: #fff;
    cursor: pointer;
  }
  .ques-icon {
    width: 8px;
    height: 44px;
    margin-right: 15px;
    background: url("../../icons/right-arrow.svg") no-repeat right center;
  }

  .ques-item:nth-last-child(1) {
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/more-relevant/more-relevant.vue